exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".clearfix:after {\n  content: \"\";\n  display: table;\n  clear: both;\n}\n.img-container-outer .img-contaienr-inner {\n  display: inline-block;\n  position: relative;\n}\n.img-container-outer .remove-btn {\n  position: absolute;\n  top: 0.333em;\n  right: 0em;\n  text-shadow: 0px 0.5px 5px rgba(0, 0, 0, 0.6);\n}\n.img-container-outer .remove-btn:before {\n  font-size: 1.5em;\n}\nimg {\n  border: 2px solid #dddddd;\n  max-width: 100%;\n  max-height: 38.443em;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/survey/photo-question/photo-question.component.less
// module id = 287
// module chunks = 1